import { ref, inject } from 'vue'
import { defineStore } from 'pinia'
import { useTheme } from 'vuetify'
import type { ApplicationConfig } from '@/types'
import axios from 'axios'

export const useConfigStore = defineStore('config', () => {
  const theme = useTheme()
  const config = ref<ApplicationConfig>()
  const defaults = ref({
    maxDuration: import.meta.env.VITE_MAX_DURATION ?? 8,
    maxYearlyMileage: import.meta.env.VITE_MAX_YEARLY_MILEAGE ?? 100000,
    maxTotalMileage: import.meta.env.VITE_MAX_TOTAL_MILEAGE ?? 250000
  })

  async function getConfig() {
    try {
      const { data } = await axios.get<ApplicationConfig>('app/current-application')

      config.value = data
      applyTheme(config.value)
      return data
    } catch (error) {
      console.error(error)
    }
  }

  function applyTheme(config: ApplicationConfig) {
    const currentTheme = config.dark ? theme.themes.value.dark : theme.themes.value.light
  
    if (config.primaryColor) {
      currentTheme.colors.primary = config.primaryColor
    }
  
    if (config.secondaryColor) {
      currentTheme.colors.secondary = config.secondaryColor
    }
  
    if (config.backgroundColor) {
      currentTheme.colors.background = config.backgroundColor
    }

    if (config.font) {
      document.body.style.fontFamily = `'${config.font}',${document.body.style.fontFamily}`
    }
  }

  return { config, defaults, getConfig, applyTheme }
})
